/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_widgets.js                                                                            */
/**********************************************************************************************************************/
/* Controller.Widgets */

var RTWidget = {
  filterType:null,
  setPushActive: function(lineId){
    var pushButton = Hafas('[data-pushline-id="' + decodeURIComponent(lineId) +'"]',false);
    if(pushButton){
       var anchor = Hafas('a', false, pushButton);
       var icon = Hafas('i',false,pushButton);
       anchor.href = Hafas.Config.Webviews.lineoverview.appId + '://unsubscribe?id=' + decodeURIComponent(lineId);
       icon.className = 'haf_menu_push_active';
    }
  },
  setPushInactive: function(lineId){
    var pushButton = Hafas('[data-pushline-id="' + decodeURIComponent(lineId) +'"]',false);
    if(pushButton){
      var anchor = Hafas('a', false, pushButton);
      var icon = Hafas('i',false,pushButton);
      anchor.href = Hafas.Config.Webviews.lineoverview.appId + '://subscribe?id=' + decodeURIComponent(lineId);
      icon.className = 'haf_menu_push_inactive';
    }
  }
};

HafasWebview.prototype.Controller = {};
HafasWebview.prototype.Controller.Webviews = {
  openURL: function(data){
    window.open(data.url,data.target);
  },
  init: function (webviewId) {
    var params = {};
    location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) { // sanitize
      key = Hafas.Core.sanitize(key);
      value = Hafas.Core.sanitize(value);
      params[key] = decodeURIComponent(value);
    });
    Hafas.Modules.appInterface.observeHeight();
    if (typeof this.Controller.Webviews.renderer[webviewId] == 'function') {
      Hafas.bind(this.Controller.Webviews.renderer[webviewId], this)(params);
    }
  },
  getPlatformLinkDeeplink: function(platform,data) {
    var platformLong = '';
    var deepLink = '';
    switch(platform){
      case 'AND': platformLong = 'ANDROID'; break;
      case 'IPH': platformLong = 'IOS'; break;
      case 'WEB': platformLong = 'WEB'; break;
    };
    if(typeof data["DEEP_LINK_" + platformLong] != 'undefined') {
      return data["DEEP_LINK_" + platformLong];
    }
  },
  common: {
    atomToggleContainer: function (data) {
      // Auslösenden Button feststellen, wenn nicht dieser übergeben wurde, sondern der zu schließende Container
      if (!data.hasOwnProperty('trigger') && data.hasOwnProperty('target')) {
        var triggerId = Hafas("#" + data.target).getAttribute('aria-labelledby');
        data.trigger = Hafas("#" + triggerId);
      }
      if (!data || !data.trigger) {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Missing "data.trigger" attribute in onclick-event.');
        return;
      }

      var _me = this;
      var clickedButton = data.trigger;

      if (!(clickedButton.tagName.toLowerCase() === "button" ||
          clickedButton.getAttribute('role') === "button") &&
          !clickedButton.hasAttribute('aria-controls')) {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Missing "aria-controls" attribute on <button>.');
        return;
      }

      var ariaControls = clickedButton.getAttribute('aria-controls');
      var containerId = '#' + ariaControls;
      var guiCommon = _me.Controller.Webviews.common;
      var atomStore = guiCommon.atomStorePreviousToggleButtons;

      // Eventuell möchte man alte Container wieder ausblenden
      if (typeof data.prevContId === "string" &&
          typeof atomStore === "object" &&
          atomStore[data.prevContId] &&
          clickedButton !== atomStore[data.prevContId]) {
        // Eigener Aufruf um alle verknüfte Container auszublenden
        Hafas.ps.pub('/GUI/common/atomToggleContainer', [{
          trigger: atomStore[data.prevContId],
          prevContId: data.prevContId,
          event: data.event
        }]);
        // Lösche Referenz des DOM-Buttons
        atomStore[data.prevContId] = null;
      }

      // Ermittel den Sichtbarkeitsstatus und wende aria-expanded an.
      var newVisibilityStatus = true;
      // übergebener Status ob Sichtbar/Offen oder geschlossen
      if (data.hasOwnProperty('open')) {
        newVisibilityStatus = data.open;
      } else if (clickedButton.getAttribute('aria-expanded') === "false" || !clickedButton.hasAttribute('aria-expanded')) {
        newVisibilityStatus = true;
        // Buttons im Array speichern ab, um alle Container der id zu schließen
        if (data.prevContId) {
          if (typeof data.prevContId === "string") {
            // Erstelle dynamisch die IdListe
            if (typeof atomStore !== "object") {
              guiCommon.atomStorePreviousToggleButtons = {};
            }
            atomStore[data.prevContId] = clickedButton;
          } else {
            console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Attribute "data.prevContId" must be a string.');
          }
        }
      } else {
        newVisibilityStatus = false;
        if (typeof data.prevContId === "string" &&
            typeof atomStore[data.prevContId] !== "undefined" &&
            atomStore[data.prevContId] !== null) {
          // Alte Container zurücksetzen
          atomStore[data.prevContId] = null;
        }
      }

      clickedButton.setAttribute('aria-expanded', newVisibilityStatus);
      // Genannten Container einblenden
      var containerToToggle = Hafas(containerId);
      if (containerToToggle) {
        // unlockFocus sollte vor dem Ausblenden angewendet werden.
        if (data.hasOwnProperty('blockFocus') && data.blockFocus === true && !newVisibilityStatus) {
          Hafas.Util.gui.dialog.unlockFocus(containerToToggle);
        }
        // Blendet umliegende Container mit aria-hidden aus.
        if (data.hasOwnProperty('surrounding') && data.surrounding === true) {
          if (newVisibilityStatus) {
            Hafas.Util.gui.dialog.hideSurrounding(containerToToggle);
          } else {
            Hafas.Util.gui.dialog.showSurrounding(containerToToggle);
          }
        }
        Hafas.Util.gui.setVisibility(containerToToggle, newVisibilityStatus);


        // Blockt den Fokus auf den Container
        if (data.hasOwnProperty('blockFocus') && data.blockFocus === true && newVisibilityStatus) {
          Hafas.Util.gui.dialog.blockFocus(containerToToggle);
        }
      } else {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: No container with "aria-controls"-Id found.');
      }

      if (data.event) {
        data.event.stopPropagation();
      }
      Hafas.ps.pub('/app/events/resize');
      return newVisibilityStatus;
    },
  },
  prepareWebviewData: function (resultData) {
    var dataList = {};
    var common = resultData.common;
    var locL = resultData.locL;
    if (typeof locL != 'undefined' && locL.length > 0 && typeof locL[0].msgL != 'undefined') {
      for (var m = 0; m < locL[0].msgL.length; m++) {
        var msg = locL[0].msgL[m];
        if (msg.tagL.indexOf("RES_WEB") != -1) {
          var remark = common.remL[msg.remX];
          dataList[remark.code] = remark.txtN;
        }
      }
    }
    return dataList;
  },
  lineoverview: {
    /* Funktionen für Linien-Overview */
    favorites: {},
    subscribedLines: {},
    toggleHimMessages: function(data){
      var lineData = Hafas.Modules.Render.objectKeeper.get(data.lineRef);

      var targetContainer = Hafas('#HFS_Webview_HimContainer_' + lineData.prodResolved.domId,false,this.Controller.Webviews.lineoverview.currentContainer);

      if(Hafas.Util.gui.getVisibility(targetContainer) == false) {
        if (lineData.prodResolved.himIdL !== undefined) {
          var himSearchReq = Hafas.Core.newType('hafasHCIRequestObject', 'HimSearch', {});
          for (var h = 0; h < lineData.prodResolved.himIdL.length; h++) {
            var currentHid = lineData.prodResolved.himIdL[h];
            himSearchReq.add('req.himFltrL');
            himSearchReq.add('req.himFltrL.type', 'HIMID');
            himSearchReq.add('req.himFltrL.mode', 'INC');
            himSearchReq.add('req.himFltrL.value', currentHid);
          }

          var hciHimRequest = Hafas.Core.newType('hafasHCIRequest', {requests: [himSearchReq]});

          Hafas.Core.newType("hafasRequest", {
            hciRequestObj: hciHimRequest,
            requestType: 'hci',
            callback: Hafas.bind(function (data) {
              if (typeof data.svcResL != 'undefined' && data.svcResL.length > 0) {
                var himResult = data.svcResL[0].res;
                var common = himResult.common;
                var msgL = himResult.msgL || [];
                for(var m=0; m < msgL.length;m++){
                  Hafas.Util.getRef("ico", common, msgL[m]);
                }
                targetContainer.innerHTML = Hafas.Modules.Render.renderTemplate("Common_Webview_Lineoverview_HimMessages", {msgL: msgL});
                Hafas.Util.gui.setVisibility(targetContainer, true);
              }
            }, this)
          });
        }
      }else{
        Hafas.Util.gui.setVisibility(targetContainer, false);
      }
    },
    toggleFavorite: function(obj){
      var domElem = obj.elem;
      var data = Hafas.Modules.Render.objectKeeper.get(obj.dataRef);
      var storage = Hafas.Core.newType("hafasStorage");
      var lineoverviewStorageId = 'webview_lineoverview_' + Hafas.Config.Storage.id;
      var currentStore = storage.get(lineoverviewStorageId);

      if(currentStore == null){
        var jsonStore = [];
      }else{
        try {
          jsonStore = JSON.parse(currentStore)
        }catch(e){
          jsonStore = [];
        }
      }

      var iconElem = Hafas('i', false,domElem);
      if(domElem.getAttribute("data-active") != "false"){
        iconElem.className = 'haf_ic_fav';
        for(var d=jsonStore.length - 1; d >= 0; d--){
          if(jsonStore[d] == data.lineId){
             jsonStore.splice(d, 1);
          }
        }
        domElem.setAttribute("data-active",false);
        delete this.Controller.Webviews.lineoverview.favorites[data.lineId];
      }else{
        domElem.setAttribute("data-active",true);
        iconElem.className = 'haf_ic_fav_active';
        jsonStore.push(data.lineId);
      }

      storage.set(lineoverviewStorageId, JSON.stringify(jsonStore));

    },
    loadLineOverviewByCls: function (dataLine, callback) {
      var requests = [];
      if(dataLine.isFavorites === true){
        var favs = this.Controller.Webviews.lineoverview.favorites;
        if(Object.keys(favs).length > 0) {
        for(var f in favs){
          var lineSearchReq = Hafas.Core.newType('hafasHCIRequestObject', 'LineDetails', {
            'req.lineId': f
          });
          requests.push(lineSearchReq);
        }
        }else{
          Hafas('#HFS_LineOverview_Favorites',false).innerHTML = Hafas.Modules.Render.renderTemplate("Common_Webview_Lineoverview_NoFavorites");
          return;
        }
      }else {
        var cls = dataLine.cls;
        // Kategoriefilter setzen
        var jnyTreeReq = Hafas.Core.newType('hafasHCIRequestObject', 'LineSearch', {
          'req.getStatus': true,
          'req.reslvHimMsgs':true,
          'req.jnyFltrL.type': 'PROD',
          'req.jnyFltrL.mode': 'INC',
          'req.jnyFltrL.value': cls
        });
        requests.push(jnyTreeReq);
      }

      var hciJnyTreeRequest = Hafas.Core.newType('hafasHCIRequest', {requests: requests });

      Hafas.Core.newType("hafasRequest", {
        hciRequestObj: hciJnyTreeRequest,
        requestType: 'hci',
        callback: Hafas.bind(function (data) {
          if (typeof data.svcResL != 'undefined' && data.svcResL.length > 0) {
            if (data.svcResL[0].err == "OK") {
              if(dataLine.isFavorites === true){
                // Iteriere über alles Ergebnisse, um Favoriten Linien zu ermitteln:
                var lines = [];
                for(var d=0; d < data.svcResL.length;d++){
                  lines = lines.concat(Hafas.bind(this.Controller.Webviews.lineoverview.processLineOverviewFav, this)(data.svcResL[d]));
                }
              }else {
                var lines = Hafas.bind(this.Controller.Webviews.lineoverview.processLineOverviewData, this)(data.svcResL[0], dataLine);
              }
              if (typeof callback == 'function') {
                callback(lines);
              }
            } else {
              console.warn("Something went wrong...");
            }
          }
        }, this)
      });
    },
    processLineOverviewFav: function(result){
      var common = result.res.common;
      var childRefL;
      var processedLines = [];
      Hafas.Util.getRef("prod", common, result.res.line);
      result.res.line.isFavorite = true;
      result.res.line.prodResolved.domId = this.Controller.Webviews.lineoverview.createDomIdFromPid(result.res.line.prodResolved.pid);
      processedLines.push(result.res.line);
      return processedLines;
    },
    createDomIdFromPid: function(pid){
      var domId = pid.replace(/\:/g, "_").replace(/\*/g, "_");
      return domId;
    },
    processLineOverviewData: function (result, dataLine) {
      var lineL = result.res.lineL;
      var common = result.res.common;
      var childRefL;
      var processedLines = [];
      for(var l=0; l < lineL.length;l++){
         var tmpLine = lineL[l];
         if(tmpLine.lineId !== undefined) {
           Hafas.Util.getRef("prod", common, tmpLine);
           tmpLine.prodResolved.domId = this.Controller.Webviews.lineoverview.createDomIdFromPid(tmpLine.prodResolved.pid);
           if (this.Controller.Webviews.lineoverview.subscribedLines !== undefined && this.Controller.Webviews.lineoverview.subscribedLines[tmpLine.prodResolved.pid] !== undefined) {
             tmpLine.prodResolved.isSubscribed = true;
           }else{
             tmpLine.prodResolved.isSubscribed = false;
           }
           if (this.Controller.Webviews.lineoverview.favorites[tmpLine.lineId] !== undefined) {
             tmpLine.isFavorite = true;
           }else{
             tmpLine.isFavorite = false;
           }
           processedLines.push(tmpLine);
         }
      }
      return processedLines;
    },
    loadSubscribedLines: function(){
      try {
        // Subscribed Lines über Schnittstellenfunktion abholen
        var subscribedLines = LinePushInterface.getSubscribedLines();
        var subscribedLinesDecoded = decodeURIComponent(subscribedLines);
        var subscribedLinesArr = subscribedLinesDecoded.split("@");
      }catch(e){
        // S18 Testfall
        var subscribedLinesArr = [];
        alert("LinePushInterface not available");
      }
      for(var s=0; s < subscribedLinesArr.length;s++){
          this.Controller.Webviews.lineoverview.subscribedLines[subscribedLinesArr[s]] = true;
      }
    },
    renderLineOverviewResult: function (lines, targetContainer) {
      targetContainer.innerHTML = Hafas.Modules.Render.renderTemplate("Common_Webview_Lineoverview_Lines", {lines: lines});

      // Prüfen ob Linie aufgeklappt werden soll
      if(this.Controller.Webviews.lineoverview.expandLine){
        var expandButton = Hafas('[data-button-pid="' + this.Controller.Webviews.lineoverview.expandLine + '"]',false);
        if(expandButton){
          expandButton.onclick();
          var posY = Hafas.Util.getPosY(expandButton);
          window.scrollTo(0,posY);
        }
      }

    },
    renderLoadingScreen: function(targetContainer){
      targetContainer.innerHTML = Hafas.Modules.Render.renderTemplate("Common_Webview_Lineoverview_Loading", {});
    }
  },
  renderer: {
    /* Kundenanpassung */
    privacy: function (params) {
      Hafas.Modules.Loader.loadTemplateFiles(['privacy.index.html'], function () {
        Hafas('#HFS_Webview', false).innerHTML = Hafas.Modules.Render.renderTemplate("Privacy_Webview");
      });
    },
    terms: function (params) {
      Hafas.Modules.Loader.loadTemplateFiles(['conditions.index.html'], function () {
        Hafas('#HFS_Webview', false).innerHTML = Hafas.Modules.Render.renderTemplate("Conditions_Index");
      });
    },
    /* Kundenanpassung Ende */
    mcp_loc_based: function (urlParams) {
      // Kategoriefilter setzen
      var locDetailsReq = Hafas.Core.newType('hafasHCIRequestObject', 'LocDetails', {
        'req.locL.extId': urlParams.extId,
        'req.locL.type': urlParams.type
      });

      var hciLocDetailsRequest = Hafas.Core.newType('hafasHCIRequest', {requests: [locDetailsReq]});

      Hafas.Core.newType("hafasRequest", {
        hciRequestObj: hciLocDetailsRequest,
        requestType: 'hci',
        callback: Hafas.bind(function (data) {
          if (typeof data.svcResL != 'undefined' && data.svcResL.length > 0) {
            if (data.svcResL[0].err == "OK") {
              var transformedData = Hafas.Util.location.prepareMCPData(data.svcResL[0].res,urlParams.clientType);
              Hafas.Modules.Loader.loadTemplateFiles(['map.flyout.html'], function () {
                Hafas('#HFS_Webview', false).innerHTML = Hafas.Modules.Render.renderTemplate("Common_Flyout_MCP_Content", transformedData);
              });
            } else {
              Hafas.Modules.Loader.loadTemplateFiles(['map.flyout.html'], function () {
                Hafas('#HFS_Webview', false).innerHTML = Hafas.Modules.Render.renderTemplate("Common_Flyout_MCP_Error", transformedData);
              });
            }
          }
        }, this)
      });
    },
    lineoverview: function(urlParams){
      Hafas.Core.newType("hafasAtoms", {
        Controller: this.Controller
      });

      var conf = Hafas.Config.Webviews.lineoverview.configuration;

      if(urlParams.showLine !== undefined){
        // Die Produktklasse aus der PID muss leider sehr umständlich über nach einanderfolgende Requests JourneyTree & LineDetails
        // ermittelt werden
        var jnyTreeReq = Hafas.Core.newType('hafasHCIRequestObject', 'JourneyTree', {
          'req.pid': urlParams.showLine
        });
        var hciJnyTreeRequest = Hafas.Core.newType('hafasHCIRequest', {requests: [jnyTreeReq] });
        Hafas.Core.newType("hafasRequest", {
          hciRequestObj: hciJnyTreeRequest,
          requestType: 'hci',
          callback: Hafas.bind(function (data) {
            if(data.svcResL !== undefined && data.svcResL.length > 0) {
              var result = data.svcResL[0].res;
              var common = result.common;
              if (result.jnyTreeNodeL !== undefined && result.jnyTreeNodeL.length > 0) {
                var lineId = common.prodL[result.jnyTreeNodeL[0].prodX].prodCtx.lineId;
                var lineDetailsReq = Hafas.Core.newType('hafasHCIRequestObject', 'LineDetails', {
                  'req.lineId': lineId
                });

                var hciJnyTreeRequest = Hafas.Core.newType('hafasHCIRequest', {requests: [lineDetailsReq]});
                Hafas.Core.newType("hafasRequest", {
                  hciRequestObj: hciJnyTreeRequest,
                  requestType: 'hci',
                  callback: Hafas.bind(function (dataLineDetails) {
                    if(dataLineDetails.svcResL !== undefined && dataLineDetails.svcResL.length > 0){
                      var resultLineDetails = dataLineDetails.svcResL[0].res;
                      var commonLine = resultLineDetails.common;
                      if(resultLineDetails.line !== undefined){
                         var product = commonLine.prodL[resultLineDetails.line.prodX];
                         var cls = product.cls;
                          // Tab ermitteln auf welches gesprungen werden soll:
                          for(var t=0; t < conf.productclasses.length;t++){
                             var tmpProd = conf.productclasses[t];
                             if((tmpProd.cls & cls) == cls){
                               this.Controller.Webviews.lineoverview.expandLine = urlParams.showLine;
                               this.Controller.Webviews.lineoverview.segControl.setActiveIndex(t);
                             }
                          }
                      }
                    }
                  }, this)
                });

              }
            }
          }, this)
        });
      }

      var model = {
        panels: conf.productclasses
      };
      if(conf.favorites == true){
        model.panels.push({
          isFavorites: true
        });
      }
      var lineOverviewCtrl = this.Controller.Webviews.lineoverview;
      Hafas.bind(lineOverviewCtrl.loadSubscribedLines,this)();


      Hafas.Modules.Loader.loadTemplateFiles(['common.webview.html','common.icons.html','common.content.html','common.new.html','common.buttons.html','common.segmentedControl.html','common.loading.html'], function () {
        Hafas('#HFS_Webview', false).innerHTML = Hafas.Modules.Render.renderTemplate("Common_Webview_Lineoverview_Main", model);

        // Segmented Control initialisieren:
        var segmentedControl = Hafas.Core.newType('HafasSegmentedControl', {
          holder: 'HFS_WebviewLineOverviewNavi',
          callback: function(data){
            var selPanelData = model.panels[data.activeIndex];
            if(selPanelData.isFavorites !== undefined && selPanelData.isFavorites){
              var targetContainer = Hafas('#HFS_LineOverview_Favorites');
            }else {
              var targetContainer = Hafas('#HFS_LineOverview_' + selPanelData.cls);
            }

            this.Controller.Webviews.lineoverview.currentContainer = targetContainer;

            // Storage
            var lineoverviewStorageId = 'webview_lineoverview_' + Hafas.Config.Storage.id;
            var storage = Hafas.Core.newType("hafasStorage");
            var currentStore = storage.get(lineoverviewStorageId);
            var favStore = this.Controller.Webviews.lineoverview.favorites;
            if(currentStore !== null){
               var jsonStore = JSON.parse(currentStore);
               for(var j=0; j < jsonStore.length;j++){
                   favStore[jsonStore[j]] = true;
               }
            }
            Hafas.bind(lineOverviewCtrl.renderLoadingScreen,this)(targetContainer);

            Hafas.bind(lineOverviewCtrl.loadLineOverviewByCls,this)(selPanelData,Hafas.bind(function(lines){
              Hafas.bind(lineOverviewCtrl.renderLineOverviewResult,this)(lines,targetContainer);
            },this));
          }.bind(this)
        }).initiate();
        this.Controller.Webviews.lineoverview.segControl = segmentedControl;
      }.bind(this));
    },
    ecocheck: function(urlParams){
      /* Profi Umweltvergleich */
      if (typeof this.subscriptions.ecocheck != 'undefined') {
        this.subscriptions.ecocheck(this);
      }
      Hafas.Core.newType("hafasAtoms", {
        Controller: this.Controller
      });

      var ecoCheckParams = {type:'webview'};
      if(urlParams && urlParams.ctxRecon){
        ecoCheckParams.ctxRecon = urlParams.ctxRecon;
      }

      Hafas.Modules.Loader.loadTemplateFiles(['common.webview.html','common.input_selectbox.html','common.icons.html','common.content.html','common.new.html','common.buttons.html','common.segmentedControl.html','common.loading.html','common.input.html','tp.result.overview.html','ecocheck.result.html'], function () {
        Hafas.ps.pub('/ecocheck/openEcoCheck',[ecoCheckParams]);
      }.bind(this));
    },
    infopage: function (urlParams) {
      Hafas.Modules.Loader.loadTemplateFiles(['common.webview.html'], function () {
        Hafas('#HFS_Webview', false).innerHTML = Hafas.Modules.Render.renderTemplate("Common_Webview_InfoFAQ", {});
      });
    },
    testParams: function (params) {
      Hafas('#HFS_Webview', false).innerHTML = '<pre>' + JSON.stringify(params, null, 2) + '</pre>';
    },
    appInterfaceTest: function(params) {
      Hafas.Modules.appInterface.observeHeight();

      function HightHandler() {

        var maxHeight = 500;
        var minHeight = 100;
        var stepsSize = 100;

        this.currentHeight = minHeight;

        document.getElementById("HFS_TestContainer").style.height = this.currentHeight + "px";
        document.body.scrollHeight = this.currentHeight + "px";
        document.getElementById("HFS_Height").innerHTML = "Height:" + this.currentHeight;

        this.changeHeight = function() {
          if (this.currentHeight < maxHeight) {
            this.currentHeight += stepsSize;
          } else {
            this.currentHeight = minHeight;
          }
          document.getElementById("HFS_TestContainer").style.height = this.currentHeight + "px";
          document.getElementById("HFS_Height").innerHTML = "Height:" + this.currentHeight;
        }
      }

      Hafas.Modules.Loader.loadTemplateFiles(['common.webview.html'], function () {
        Hafas('#HFS_Webview', false).innerHTML = Hafas.Modules.Render.renderTemplate("Common_Webview_AppInterfaceTest", {});
        window.hightHandler = new HightHandler();

      });

    }
  }
};
